'use strict';

require("core-js/modules/es6.regexp.match");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.for-each");

exports.__esModule = true;
var blackList = ['defaultProps', 'propTypes', 'contextTypes', 'childContextTypes', 'displayName'];

var statics = exports.statics = function statics(Target, Component) {
  Object.keys(Component).forEach(function (property) {
    if (blackList.indexOf(property) === -1) {
      Target[property] = Component[property];
    }
  });
};

var fetchDataByPath = exports.fetchDataByPath = function fetchDataByPath(object, path) {
  if (!object || !path) {
    return false;
  }

  path = path.toString();
  var field = path.split('.');
  var val = void 0,
      key = void 0;

  if (field.length) {
    key = field[0]; // lists[1].name

    if (key.indexOf('[') >= 0) {
      key = key.match(/(.*)\[(.*)\]/);

      if (key) {
        val = object[key[1]][key[2]];
      }
    } else {
      val = object[field[0]];
    }

    if (val) {
      for (var colIndex = 1; colIndex < field.length; colIndex++) {
        val = val[field[colIndex]];

        if (typeof val === 'undefined') {
          break;
        }
      }
    }
  }

  return val;
};